<template>
  <div class="content-center">
    <div class="banner">
      <div class="content">
        <div class="banner-title">会员CRM解决方案</div>
        <div class="line" />
        <div class="desc">
          以营销互动为中心的全域客户管理系统
          深度客户管理，挖掘客户价值，洞察客户行为，高效跟进客户，实现持续可复制的业绩增长
        </div>
        <div class="btn-wrap">
          <div
            class="btn"
            @click="openModal"
          >免费试用</div>
        </div>
      </div>
    </div>
    <div class="block-m01">
      <div class="sk-block-title">
        <div class="title">您是否遇到这些问题？</div>
      </div>
      <div class="content-01">
        <div v-for="(item, index) in problemList" :key="`problemList_0${index+1}`" class="item">
          <img :src="require(`@/assets/images/solution/member-icon-0${index+1}.png`)" alt="">
          <div class="name" v-html="item" />
        </div>
      </div>
    </div>
    <div class="block-m02">
      <div class="content-02">
        <img src="@/assets/images/solution/member-pic-01.png" alt="">
      </div>
    </div>
    <div class="block-m01">
      <div class="sk-block-title">
        <div class="title">会员crm全生命周期管理解决方案</div>
      </div>
      <div class="content-03">
        <div v-for="(item, index) in schemeList" :key="`schemeList_0${index+1}`" class="item">
          <img :src="require(`@/assets/images/solution/member-icon1-0${index+1}.png`)" alt="">
          <div class="title" v-html="item.title" />
          <div class="line" />
          <div class="sub-title">{{ item.subTitle }}</div>
        </div>
      </div>
    </div>
    <div class="block-m02">
      <div class="sk-block-title">
        <div class="title">聚焦核心场景深入</div>
      </div>
      <div class="content-04">
        <div class="item item-01">
          <div class="item-lf">
            <div class="name">线上拉新预与转化</div>
            <div class="line" />
            <div class="title">
              <img class="icon" src="@/assets/images/solution/member-num-01.png" alt="">
              多渠道为店铺做定向推荐拉新，触达更多新用户
            </div>
            <div class="sub-title"><span class="dot" />流量坑位资源监控及预测，在排名靠前的流量坑位中进行露出</div>
          </div>
          <div class="item-img">
            <img src="@/assets/images/solution/member-ad-01.png" alt="">
          </div>
        </div>
        <div class="item item-02">
          <div class="item-img">
            <img src="@/assets/images/solution/member-ad-02.png" alt="">
          </div>
          <div class="item-lf">
            <div class="title">
              <img class="icon" src="@/assets/images/solution/member-num-02.png" alt="">
              同一领域商品关联推荐，并叠加促销，提高客单价，提高库存周转效率，提升店铺的利润增长
            </div>
            <div class="sub-title"><span class="dot" />关联/搭配品推荐</div>
            <div class="sub-title"><span class="dot" />虚实商品结合</div>
          </div>
        </div>
        <div class="item item-03">
          <div class="item-lf">
            <div class="title">
              <img class="icon" src="@/assets/images/solution/member-num-03.png" alt="">
              对已流失或者在流失边缘的店铺粉丝进行召回，唤醒沉睡用户，挖掘更多用户价值
            </div>
            <div class="sub-title"><span class="dot" />自动为店铺创建唤醒活动，通过短信形式将活动链接传达给用户群体</div>
          </div>
          <div class="item-img">
            <img src="@/assets/images/solution/member-ad-03.png" alt="">
          </div>
        </div>
        <div class="item item-01" style="margin-top: 100px;">
          <div class="item-lf">
            <div class="name">导流线下与裂变</div>
            <div class="line" />
            <div class="title">
              <img class="icon" src="@/assets/images/solution/member-num-01.png" alt="">
              利用内外部媒体产品矩阵，直播、短视频等，线上流量引导至线下，增加用户和店铺的互动频率
            </div>
            <div class="sub-title"><span class="dot" />用户获得线上优惠券，到店消费即可享受折扣优惠</div>
          </div>
          <div class="item-img">
            <img src="@/assets/images/solution/member-ad-04.png" alt="">
          </div>
        </div>
        <div class="item item-02">
          <div class="item-img">
            <img src="@/assets/images/solution/member-ad-05.png" alt="">
          </div>
          <div class="item-lf">
            <div class="title">
              <img class="icon" src="@/assets/images/solution/member-num-02.png" alt="">
              设置平台会员日固定促活运营活动，签到+分享+汇金币，支持引流到门店兑换
            </div>
            <div class="sub-title"><span class="dot" />平台会员日固定时间点签到并成功提醒N个粉丝签到成功，可获得大额汇金币，支持兑换话费或实物礼品</div>
          </div>
        </div>
        <div class="item item-03">
          <div class="item-lf">
            <div class="title">
              <img class="icon" src="@/assets/images/solution/member-num-03.png" alt="">
              在外部媒体产品中投放推广广告，将线上流量引导具体门店
            </div>
            <div class="sub-title"><span class="dot" />购买广告推广套餐，可将店铺活动等信息在外部的产品终端进行定向推广</div>
          </div>
          <div class="item-img">
            <img src="@/assets/images/solution/member-ad-06.png" alt="">
          </div>
        </div>
      </div>
    </div>
    <div class="sk-flex8">
      <div class="sk-block-title">
        <div class="title">行业解决方案</div>
      </div>
      <div class="sk-flex8-icon-name">
        <div v-for="(item, index) in solutionList" :key="`solutionList_0${index+1}`" class="item">
          <img :src="require(`@/assets/images/solution/member-icon2-0${index+1}.png`)" alt="">
          <div class="name">{{ item }}</div>
        </div>
      </div>
    </div>
    <CarouselItem title="会员CRM" />
    <ConsultForm info-sources="会员CRM" title="咨询服务 立即预约" />
    <TryModal v-if="visible" :visible="visible" info-sources="会员CRM" @cancel="modalClose" />
  </div>
</template>
<script>
import metaInfo from '@/common/util/metaInfo'
import ConsultForm from '@/components/ConsultForm'
import TryModal from '@/components/TryModal'
import CarouselItem from '@/components/CarouselItem'

export default {
  metaInfo: metaInfo.Member,
  name: 'Member',
  components: {
    ConsultForm,
    TryModal,
    CarouselItem
  },
  data() {
    return {
      visible: false,

      problemList: ['获客难度大、<br/>成本高', '客户资料零散，<br/>统一管理艰难', '纸质化办公，<br/>数据资料无法长久留存', '团队内部工作流程规范度低，<br/>工作效率低下'],
      schemeList: [
        {
          title: '全渠道引流获客<br/>沉淀私域资产',
          subTitle: '深入全渠道获客场景，通过二维活码覆盖线上/线下获客渠道，激活客户触点'
        },
        {
          title: '客户360°视图<br/>促进客户服务与价值提升',
          subTitle: '客户基础信息、跟进记录、商机信息等全面记录永久保存，将碎片化客户信息沉淀为客户数据资产。'
        },
        {
          title: '精细运营赋能<br/>激活客户复购转化',
          subTitle: '圈选目标客户标签，通过个性化内容营销，挖掘客户深度需求，打造个性化客户旅程，促进转化'
        },
        {
          title: '自动化运营<br/>提升客户价值',
          subTitle: '针对不同生命周期阶段的客户，灵活配置针对性的运营流程，自由组合运营工具。'
        }
      ],
      solutionList: ['家用电器', '农资行业', '交通出行', '酒水饮料', '家居建材', '数码3C', '餐饮行业', '快消行业']
    }
  },
  methods: {
    openModal: function() {
      this.visible = true
    },
    modalClose: function(data) {
      this.visible = data
    }
  }
}
</script>
<style lang="less" scoped>
.banner {
  background: url("~@/assets/images/solution/member_banner.png") no-repeat center;
  background-size: 100% 100%;
  min-width: 1200px;
  .content {
    width: 1200px;
    margin: 0 auto;
    padding: 53px 0;
    text-align: left;
    .banner-title {
      font-size: 48px;
      color: #FFFFFF;
      line-height: 55px;
    }
    .line {
      width: 100px;
      height: 6px;
      background: #28DAFB;
      margin: 16px 0 31px;
    }
    .desc {
      width: 484px;
      height: 101px;
      font-size: 22px;
      color: #FFFFFF;
      line-height: 38px;
    }
    .btn-wrap {
      .btn {
        width: 200px;
        height: 58px;
        line-height: 58px;
        border-radius: 6px;
        border: 1px solid #FFFFFF;
        font-size: 22px;
        color: #FFFFFF;
        cursor: pointer;
        text-align: center;
        margin-top: 47px;
      }
    }
  }
}
.line {
  width: 30px;
  height: 2px;
  background: #6038EA;
}
.dot {
  width: 9px;
  height: 9px;
  border-radius: 50%;
  overflow: hidden;
  background: #6038EA;
  display: block;
}
.block-m01 {
  background: #F8F8FD;
}
.block-m02 {
  background: #fff;
}
.sk-flex8 {
  background: url(~@/assets/images/solution/member-bg-01.png) no-repeat 0 0;
}
.content-01 {
  display: flex;
  justify-content: space-around;
  padding: 60px 0 50px;
  width: 1200px;
  margin: 0 auto;
  .name {
    font-size: 18px;
    color: #595961;
    margin-top: 36px;
  }
}
.content-02 {
  margin: 89px auto 64px;
  width: 1202px;
}
.content-03 {
  width: 1110px;
  margin: 0 auto;
  padding: 63px 0 64px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  .item {
    width: 220px;
    img {
      width: 87px;
      height: 78px;
      display: block;
      margin: 0 auto 34px;
    }
    .title {
      color: #595961;
      font-size: 20px;
      font-weight: 500;
    }
    .line {
      margin: 23px auto 13px;
    }
    .sub-title {
      color: #8B8FA1;
      font-size: 14px;
      width: 210px;
      margin: 0 auto;
    }
  }
}
.content-04 {
  width: 1200px;
  margin: 0 auto;
  padding: 66px 0 41px;
  .item {
    display: flex;
    justify-content: space-around;
    color: #595961;
    margin-bottom: 20px;
    &-lf {
      text-align: left;
      width: 560px;
    }
    .name {
      font-size: 32px;
      font-weight: 600;
    }
    .line {
      height: 3px;
      margin: 25px 0 45px;
    }
    .title {
      font-size: 24px;
      margin-bottom: 15px;
      display: flex;
      font-weight: 500;
      .icon {
        width: 42px;
        height: 25px;
        margin-right: 4px;
        display: block;
      }
    }
    .sub-title {
      font-size: 18px;
      font-weight: 400;
      display: flex;
      margin-bottom: 10px;
      .dot {
        margin-left: 32px;
        margin-right: 8px;
        margin-top: 8px;
      }
    }
  }
  .item-01 {
    .item-lf {
      margin-top: 15px;
    }
    .item-img {
      width: 355px;
      margin-right: 84px;
    }
  }
  .item-02 {
    .item-lf {
      margin-top: 90px;
    }
    .item-img {
      width: 348px;
      margin-left: 72px;
    }
  }
  .item-03 {
    .item-lf {
      margin-top: 64px;
    }
    .item-img {
      width: 354px;
      margin-right: 84px;
    }
  }
}
</style>
